"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyStyles = exports.PARSE_FORM_IN_ROVIEWER_FASHION = exports.replaceURLString = void 0;
const jquery_1 = __importDefault(require("jquery"));
window.jQuery = jquery_1.default;
const datatables_net_dt_1 = __importDefault(require("datatables.net-dt"));
require("datatables.net-colreorderwithresizeupdated");
require("datatables.net-select-dt");
require("datatables.net-rowgroup-dt");
require("datatables-rowsgroup-kaihei777");
const mark_js_1 = __importDefault(require("mark.js"));
const replaceURLString = (url) => {
    if (!url || !url.includes)
        return url;
    let base_url_str = window.BASE_URL;
    base_url_str = base_url_str.replace("https://", "");
    base_url_str = base_url_str.replace("http://", "");
    base_url_str = base_url_str.replace("/", "");
    return url.includes("DASHBOARD_URL") ? url.replaceAll("DASHBOARD_URL", base_url_str) : url;
};
exports.replaceURLString = replaceURLString;
class FkDataTable {
    table_loader = `
		<div class='loader-spinner-bg'>
			<div class="lds-ring">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
			<p>Please Wait</p>
			<p>Retrieving Table Data</p>
		</div>`;
    static emptyStyles = {
        RO: `<div class="flex flex-row gap-2 text-left bg-primary-50 border-normal border-primary rounded-primary p-10 mx-auto my-10 w-max max-w-[1350px]">
			<img class="w-[350px]" src="/images/ro-empty-table.svg">
			<div class="flex flex-col gap-2">
				<h3 class="text-sub2 font-medium">There are currently no retention obligations available.</h3>
				<p class="pb-3">Usually this means that there are no available laws under this filter/search term. The Retention Viewer tells you what the law states per country, it does not provide suggestions. </p>
				<h6>Some quick fixes:</h6>
				<ul>
					<li class="relative pl-5 py-0.5 before:absolute before:left-0 before:top-[7px] before:w-3 before:h-3 before:rounded-full before:bg-primary">Search for a more generic alternative (e.g. a statute of limitations) or adjust the filters</li>
					<li class="relative pl-5 py-0.5 before:absolute before:left-0 before:top-[7px] before:w-3 before:h-3 before:rounded-full before:bg-primary">Use the MySchedule feature instead so you always get a recommended result.</li>
					<li class="relative pl-5 py-0.5 before:absolute before:left-0 before:top-[7px] before:w-3 before:h-3 before:rounded-full before:bg-primary">Do you feel we are missing something or need help? Contact us at: <a class="text-primary underline" href="mailto:support@filerskeepers.co">support@filerskeepers.co</a>.</li>
				</ul>
			</div>
		</div>`,
        DEFAULT: "No data available in table. Please adjust your filters and try again."
    };
    tableStyle;
    form_element;
    form_loading_element;
    dt_options;
    dt_wrapper;
    table;
    dt;
    LOADING_CLASS = 'fk-dt-loading';
    onSearch;
    beforeFormSubmit = (formElement) => true;
    getTable() {
        return this.dt.table().node();
    }
    constructor(tableSelector, options) {
        this.table = document.querySelector(tableSelector);
        this.tableStyle = options.tableStyle || 'fk-table';
        this.searchDt = this.searchDt.bind(this);
        this.form_element = options.formElement || undefined;
        this.#init_form_element();
        options.dataExport && this.#init_data_export(options.dataExport);
        this.dt_options = this.#construct_dt_options(options);
        if (!this.dt_options.ajax) {
            delete this.dt_options.ajax;
            this.dt_options.serverSide = false;
        }
        this.dt = new datatables_net_dt_1.default(this.table, this.dt_options);
        this.dt_wrapper = this.dt.table().container();
    }
    #init_data_export(selector) {
        document.querySelectorAll(selector).forEach(element => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                let exportUrl = element.getAttribute('href') || '';
                let exportType = element.getAttribute('data-type') || 'xlsx';
                if (!this.form_element) {
                    throw "No form to export from, please provide a form element to the constructor";
                }
                let form_data = jquery_1.default.param({ ...this.form_element?.getParsedFormObject(), export_type: exportType });
                window.open(exportUrl + '?' + form_data, '_blank');
            });
        });
    }
    #init_form_element() {
        if (this.form_element) {
            this.form_element.addEventListener('submit', async (e) => {
                e.preventDefault();
                if (this.beforeFormSubmit && this.form_element && await this.beforeFormSubmit(e)) {
                    this.searchDt();
                }
            });
            this.form_element.searchFkDt = () => {
                if (this.form_element?.getAttribute('disabled') === 'true' || this.form_element?.dataset.disabled === 'true')
                    return;
                const event = new Event('submit', { bubbles: true, cancelable: true });
                this.form_element?.dispatchEvent(event);
            };
            this.form_element.getParsedFormObject = () => {
                return this.#parse_form_data(new FormData(this.form_element));
            };
            this.form_loading_element = document.createElement('div');
        }
    }
    searchDt({ callback = () => { }, paging = true, silent = false } = {}) {
        if (this.dt && this.dt.ajax) {
            if (this.onSearch) {
                this.onSearch(this.form_element?.getParsedFormObject() || {});
            }
            if (silent) {
                const settings = this.dt.settings()[0];
                const originalProcessing = settings.oFeatures.bProcessing;
                settings.oFeatures.bProcessing = false;
                this.dt.ajax.reload(() => {
                    settings.oFeatures.bProcessing = originalProcessing;
                    callback();
                }, paging);
            }
            else {
                this.dt.ajax.reload(callback, paging);
            }
        }
    }
    camelToHyphenSmart(str) {
        return str
            .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
            .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
            .toLowerCase();
    }
    #construct_dt_options(providedOptions) {
        const defaultOptions = {
            ordering: false,
            pageLength: 20,
            paging: true,
            dom: `<"fk-data-table"<"${this.tableStyle} wrapper"Rt>r<"flex flex-row justify-between items-center pr-11 pt-6 pagination"f<"flex items-center gap-5"li><"selected-rows-count">p>>`,
            processing: true,
            serverSide: true,
            searching: false,
            pagingType: 'full_numbers',
            language: {
                processing: this.table_loader,
                paginate: {
                    next: '<span class="material-symbols-rounded-new">chevron_forward</span>',
                    previous: '<span class="material-symbols-rounded-new">chevron_backward</span>',
                    first: '<span class="material-symbols-rounded-new">first_page</span>',
                    last: '<span class="material-symbols-rounded-new">last_page</span>',
                },
                lengthMenu: "_MENU_",
                emptyTable: `${providedOptions.emptyContent ? FkDataTable.emptyStyles[providedOptions.emptyContent] : FkDataTable.emptyStyles['DEFAULT']}`
            },
            lengthMenu: [
                10, 20, 30, 50, 100, 500, 1000
            ],
            autoWidth: false,
            drawCallback: () => {
                if (this.form_element)
                    this.markSearchTerms();
            },
            columnDefs: [
                {
                    targets: "_all",
                    createdCell: (cell, cellData, rowData, row, colIndex) => {
                        const header = this.dt.column(colIndex).header();
                        const headerText = header.dataset.header || header.textContent;
                        cell.setAttribute('data-header', headerText ?? '');
                    },
                },
                ...providedOptions.columnDefs || []
            ],
            rowCallback: providedOptions.rowCallback || ((row, rowData) => {
                if (!rowData._meta)
                    return row;
                const meta = rowData._meta;
                for (let key in meta) {
                    row.setAttribute(`data-${this.camelToHyphenSmart(key)}`, meta[key]);
                }
                return row;
            }),
        };
        if (this.form_element && this.form_element.getAttribute('action')) {
            defaultOptions.ajax = {
                type: 'GET',
                crossDomain: true,
                url: this.form_element.getAttribute('action'),
                dataSrc: (data) => {
                    if (Array.isArray(data.data[0])) {
                        data.data = data.data.map((row) => {
                            return row.map((cell) => {
                                return (0, exports.replaceURLString)(cell);
                            });
                        });
                        return data.data;
                    }
                    data.data = data.data.map(({ meta, data }) => {
                        const arr = data.map((cell) => {
                            return (0, exports.replaceURLString)(cell);
                        });
                        arr._meta = meta;
                        return arr;
                    });
                    return data.data;
                },
                data: (data) => {
                    delete data.columns;
                    delete data.search;
                    if (providedOptions.requestParams) {
                        for (let key in providedOptions.requestParams) {
                            data[key] = providedOptions.requestParams[key];
                        }
                    }
                    data.form_data = JSON.stringify(this.form_element?.getParsedFormObject());
                    let dropdown_values = {};
                    if (document.querySelectorAll('.flexible-dropdown').length > 0) {
                        document.querySelectorAll('.flexible-dropdown').forEach(e => {
                            dropdown_values[e.getAttribute('id')] = e.value;
                        });
                    }
                    data.dropdown_values = JSON.stringify(dropdown_values);
                },
                beforeSend: (request) => {
                    this.table.classList.add(this.LOADING_CLASS);
                    this.form_element?.classList.add(this.LOADING_CLASS);
                    this.form_element?.setAttribute('disabled', 'true');
                    request.setRequestHeader("x-user", window.ENC_USER);
                    request.setRequestHeader("token", window.makeHash());
                    if (typeof window.ENC_ORG !== 'undefined' && window.ENC_ORG) {
                        request.setRequestHeader("x-org", window.ENC_ORG);
                    }
                },
                complete: (data) => {
                    this.table.classList.remove(this.LOADING_CLASS);
                    this.form_element?.classList.remove(this.LOADING_CLASS);
                    this.form_element?.removeAttribute('disabled');
                },
                ...providedOptions.ajax
            };
        }
        providedOptions.ajax = defaultOptions.ajax;
        providedOptions.columnDefs = defaultOptions.columnDefs;
        return {
            ...defaultOptions,
            ...providedOptions
        };
    }
    markSearchTerms() {
        (this.form_element?.querySelectorAll('input[data-fk-dt-highlight-target][type="text"]')).forEach(e => {
            if (!e.value)
                return;
            let selector = e.getAttribute('data-fk-dt-highlight-target');
            if (selector) {
                let target_elements = this.table?.querySelectorAll(selector);
                let mark = new mark_js_1.default(target_elements ?? []);
                mark.mark(e.value);
            }
        });
    }
    #parse_form_data(formData) {
        return Object.fromEntries(Object.entries(Object.fromEntries(formData.entries())).map(([k, v]) => {
            if (typeof v === 'string') {
                if (v.startsWith('[') && v.endsWith(']')) {
                    return [k, JSON.parse(v)];
                }
            }
            return [k, v];
        }));
    }
}
exports.default = FkDataTable;
const PARSE_FORM_IN_ROVIEWER_FASHION = (form) => {
    const formData = new FormData(form);
    return Object.fromEntries(Object.entries(Object.fromEntries(formData.entries())).map(([k, v]) => {
        if (typeof v === 'string') {
            if (v.startsWith('[') && v.endsWith(']')) {
                return [k, JSON.parse(v)];
            }
        }
        return [k, v];
    }).filter(([k, v]) => v !== '' && v !== null));
};
exports.PARSE_FORM_IN_ROVIEWER_FASHION = PARSE_FORM_IN_ROVIEWER_FASHION;
const emptyStyles = FkDataTable.emptyStyles;
exports.emptyStyles = emptyStyles;
